var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 1.70478C17.3258 1.98925 16.6109 2.17597 15.8788 2.25875C16.6413 1.82334 17.2268 1.13386 17.5025 0.312345C16.7776 0.722154 15.9846 1.01089 15.1575 1.16608C14.4839 0.482355 13.5242 0.0550537 12.462 0.0550537C10.4225 0.0550537 8.76894 1.63029 8.76894 3.57314C8.76894 3.84892 8.80164 4.1174 8.86457 4.37496C5.79543 4.22819 3.07433 2.82759 1.25289 0.699053C0.935074 1.21866 0.752965 1.82307 0.752965 2.46774C0.752965 3.68835 1.40497 4.76515 2.39582 5.39608C1.80937 5.37859 1.23583 5.22769 0.723082 4.95599C0.722871 4.97073 0.722871 4.98546 0.722871 5.00027C0.722871 6.70485 1.99581 8.12682 3.68514 8.45003C3.14133 8.59092 2.57091 8.61154 2.01746 8.51031C2.48736 9.90803 3.85121 10.9251 5.46714 10.9536C4.20327 11.8972 2.6109 12.4597 0.880793 12.4597C0.582668 12.4597 0.288761 12.443 -0.000152588 12.4105C1.63412 13.4087 3.57524 13.9911 5.66071 13.9911C12.4534 13.9911 16.1678 8.63022 16.1678 3.98115C16.1678 3.82855 16.1643 3.67683 16.1571 3.52598C16.8801 3.02807 17.5041 2.41135 17.9998 1.70478Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.08e37aabad9085e73defa0b2c9843877.svg";
export { ForwardRef as ReactComponent };